import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import * as fromSales from './reducers/sales.reducer';
import { EffectsModule } from '@ngrx/effects';
import { SalesEffects } from './effects/sales.effects';

@NgModule({
  declarations: [],
  imports: [
    StoreModule.forFeature(fromSales.salesFeatureKey, fromSales.reducer),
    EffectsModule.forFeature([SalesEffects]),
  ],
})
export class SalesStoreModule {}
